import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2ee09de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-xl modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "modal_media_header"
}
const _hoisted_4 = { class: "d-flex flex-wrap flex-stack mt-1 mb-1 w-50" }
const _hoisted_5 = { class: "d-flex my-2" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative me-4" }
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Tìm kiếm ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-1" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body pt-0" }
const _hoisted_12 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_create_api_key_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_create_api_key_header",
  "data-kt-scroll-wrappers": "#kt_modal_create_api_key_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_13 = {
  id: "kt_content_container",
  class: "container-fluid p-1"
}
const _hoisted_14 = { class: "row position-relative mb-5" }
const _hoisted_15 = { class: "g-6 g-xl-9 mt-1 mb-1" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = {
  key: 0,
  class: "p-5 m-0 fs-5"
}
const _hoisted_18 = {
  key: 1,
  class: "p-5 m-0 fs-5"
}
const _hoisted_19 = { class: "f-flex g-6 g-xl-9 mt-1 mb-1" }
const _hoisted_20 = { class: "breadcrumb fw-bold fs-6 my-1" }
const _hoisted_21 = { class: "breadcrumb-item" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  href: "#",
  class: "text-hover-primary"
}
const _hoisted_24 = {
  class: "row g-6 g-xl-9 mb-6 mb-xl-9",
  ref: "scrollComponent"
}
const _hoisted_25 = {
  key: 0,
  class: "card h-100 border border-gray-500"
}
const _hoisted_26 = { class: "position-relative card-body d-flex justify-content-center text-center flex-column p-0 item-media" }
const _hoisted_27 = { class: "media-action position-relative w-100" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-3" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "text-gray-800 d-flex flex-column" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder-fill" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "fs-6 fw-bolder mb-2 p-2 position-relative" }
const _hoisted_39 = ["onUpdate:modelValue", "onKeyup"]
const _hoisted_40 = {
  key: 1,
  class: "w-100 fs-6 fw-bold"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check fs-3" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "fs-7 fw-bold text-gray-400 mb-2" }
const _hoisted_45 = {
  key: 1,
  class: "card h-100 card h-100 border border-gray-500 cursor-pointer"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "multi-selectple"
}
const _hoisted_50 = { class: "form-check border border-2 border-blue-dx rounded form-check-custom form-check-solid shadow" }
const _hoisted_51 = ["value"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "symbol mb-1 symbol-150px symbol-2by3" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "fs-6 fw-bolder mb-1 p-2 h-50px overflow-hidden" }
const _hoisted_56 = { class: "fs-7 fw-bold text-gray-400 mb-2" }
const _hoisted_57 = { class: "row g-6 g-xl-9 mb-6 mb-xl-9 flex-center" }
const _hoisted_58 = { class: "modal-footer flex-center" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Chọn ảnh ", -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "modal-backdrop-show" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade modal-fullscreen fade", { show: _ctx.showMedia }]),
      id: "mediaModal",
      tabindex: "-1",
      "aria-hidden": "true",
      style: _normalizeStyle({ display: _ctx.showMedia ? 'block' : 'none' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    id: "kt_filter_search",
                    class: "form-control border-gray-600 form-control-sm w-250px",
                    placeholder: "Tìm kiếm",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch()))
                  }, null, 544), [
                    [_vModelText, _ctx.search]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary bg-blue-dx btn-sm my-3 me-5",
                  "data-kt-menu-trigger": "click",
                  "data-kt-menu-placement": "bottom-end",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch()))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" }),
                    _hoisted_8
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success bg-blue-dx btn-sm my-3",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createNewFolder()))
                }, " Thư mục mới ")
              ])
            ]),
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeMedia())),
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal"
            }, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("header", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _mergeProps(_ctx.getRootProps(), { class: "mt-5 px-7 py-3 text-white border border-dashed border-gray-300 rounded bg-opacity-70 bg-primary bg-hover-success text-hover-inverse-info text-center" }), [
                        _createElementVNode("input", _mergeProps(_ctx.getInputProps(), { accept: "image/x-png,image/gif,image/jpeg" }), null, 16),
                        (_ctx.isDragActive)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Thả ảnh để upload ... "))
                          : (_openBlock(), _createElementBlock("p", _hoisted_18, " Kéo thả ảnh hoặc nhấp chuột để đăng "))
                      ], 16)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("ul", _hoisted_20, [
                      _createElementVNode("li", _hoisted_21, [
                        _createElementVNode("span", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rootFolder())),
                          class: "text-dark cursor-pointer"
                        }, "Home")
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbData, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "breadcrumb-item text-muted",
                          onClick: ($event: any) => (_ctx.clickBreadcrumb(index)),
                          key: index
                        }, [
                          _createElementVNode("a", _hoisted_23, _toDisplayString(item.originalname), 1)
                        ], 8, _hoisted_22))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataMedia, (image, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item-img-media",
                      key: index
                    }, [
                      (image.mimetype === 'folder')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                  class: "btn btn-sm-media btn-icon btn-danger top-3px position-absolute l-100",
                                  onClick: ($event: any) => (_ctx.deleteMedia(image._id, index))
                                }, _hoisted_30, 8, _hoisted_28),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.showEditTitle[index] = true),
                                  class: "btn btn-sm-media btn-icon btn-primary top-10 position-absolute l-100"
                                }, _hoisted_33, 8, _hoisted_31)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", {
                                  class: "symbol mb-5 media-folder symbol-150px symbol-2by3 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.openFolder(image))
                                }, _hoisted_37, 8, _hoisted_35),
                                _createElementVNode("div", _hoisted_38, [
                                  (_ctx.showEditTitle[index])
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        class: "w-100 form-control-sm form-control fs-6 fw-bold text-center",
                                        contenteditable: "true",
                                        "onUpdate:modelValue": ($event: any) => ((image.originalname) = $event),
                                        onKeyup: _withKeys(($event: any) => (_ctx.updateMedia(image, index)), ["enter"])
                                      }, null, 40, _hoisted_39)), [
                                        [_vModelText, image.originalname]
                                      ])
                                    : (_openBlock(), _createElementBlock("h4", _hoisted_40, _toDisplayString(image.originalname), 1)),
                                  _withDirectives(_createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.updateMedia(image, index)),
                                    class: "btn btn-icon btn-success top-0 position-absolute btn-sm-media-check l-100"
                                  }, _hoisted_43, 8, _hoisted_41), [
                                    [_vShow, _ctx.showEditTitle[index]]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_44, _toDisplayString(image.created_at), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("button", {
                              class: "btn btn-sm-media btn-icon btn-danger top-3px position-absolute r-100",
                              onClick: ($event: any) => (_ctx.deleteMedia(image._id, index))
                            }, _hoisted_48, 8, _hoisted_46),
                            (_ctx.isMultiple)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _createElementVNode("label", _hoisted_50, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input h-20px w-20px",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectMultipleMediaData) = $event)),
                                      value: { name: image.name, path: image.path }
                                    }, null, 8, _hoisted_51), [
                                      [_vModelCheckbox, _ctx.selectMultipleMediaData]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "card-body d-flex justify-content-center text-center flex-column p-0",
                              onClick: ($event: any) => (
                        _ctx.selectMedia(_ctx.actionCall, {
                          name: image.name,
                          path: image.path,
                          width: image?.width,
                          height: image?.height,
                        })
                      )
                            }, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("img", {
                                  src: _ctx.renderImageUrl(image, 'small'),
                                  alt: "",
                                  class: "",
                                  style: {"object-fit":"cover","width":"100%"}
                                }, null, 8, _hoisted_54)
                              ]),
                              _createElementVNode("div", _hoisted_55, _toDisplayString(image.name), 1),
                              _createElementVNode("div", _hoisted_56, _toDisplayString(image.created_at), 1)
                            ], 8, _hoisted_52)
                          ]))
                    ]))
                  }), 128))
                ], 512),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreMedia()))
                  }, " Tải thêm ")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("button", {
              type: "reset",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeMedia())),
              class: "btn btn-secondary bg-hover-light-primary me-3"
            }, " Đóng "),
            (_ctx.isMultiple && _ctx.selectMultipleMediaData.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "submit",
                  id: "kt_modal_create_api_key_submit",
                  class: "btn btn-primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectMultipleMedia_(_ctx.actionCall, _ctx.selectMultipleMediaData)))
                }, _hoisted_60))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 6),
    _withDirectives(_createElementVNode("div", _hoisted_61, null, 512), [
      [_vShow, _ctx.showMedia]
    ])
  ], 64))
}